<template>
  <div class="container share-tags-cont">
    <div class="share-links">
      <p class="tbc-regular font-16">{{ $fn.tr("Share With Your Friend:") }}</p>
      <template v-for="(button, index) in getShareLinks">
        <a
          target="_blank"
          :href="button.url"
          v-html="button.svg"
          @click.stop="openSharePopup(button.url)"
          :key="index"
        >
        </a>
      </template>
    </div>
    <div class="tags-list">
      <h3 class="tbc-bold font-16 uppercase" v-if="_.size(tagList) && tagList">
        {{ $fn.tr("tags:") }}
      </h3>
      <ul>
        <filter-button
          v-for="(i, index) in tagList"
          :key="index"
          :tagId="_.get(i, 'id')"
          :title="_.get(i, 'title')"
        />
      </ul>
    </div>
  </div>
</template>

<script>
import filterButton from "@/components/filterButton";

export default {
  props: ["data"],

  components: {
    filterButton
  },
  data() {
    return {};
  },
  computed: {
    getShareLinks() {
      let socialList = [];
      let socialSvgs = _.get(
        this.$store.state.main.indx,
        "widgets.social_icons"
      );
      let uri = encodeURI(
        window.location.protocol +
          "//" +
          window.location.host +
          "" +
          this.$route.path +
          window.location.search
      );

      if (!socialSvgs) return socialList;
      for (let i in socialSvgs) {
        socialList.push({
          svg: socialSvgs[i].svg,
          url: socialSvgs[i].url + uri
        });
      }

      return socialList;
    },
    tagList() {
      if (!this.data) return;
      let tagsList = _.get(this.$store.state.main.indx, "terms.tags");
      let currentTag = this.data;
      let tags = [];

      for (let i of currentTag) {
        let list = tagsList.find(item => item.id === i);
        list ? tags.push(list) : (tags = []);
      }
      return tags;
    }
  },
  methods: {
    openSharePopup(url) {
      let winWidth = 650;
      let winHeight = 350;
      let winTop = 200;
      let winLeft = screen.width / 2 - winWidth / 2;
      window.open(
        url,
        "sharer",
        "top=" +
          winTop +
          ",left=" +
          winLeft +
          ",toolbar=0,status=0,width=" +
          winWidth +
          ",height=" +
          winHeight
      );
    }
  }
};
</script>

<style scoped>
.relative {
  position: relative;
}
.flex {
  display: flex;
}
.justify-between {
  justify-content: space-between;
}
.align-center {
  align-items: center;
}
.share-links {
  margin-top: 54px;
  display: flex;
  align-items: center;
  padding-bottom: 31px;
  border-bottom: 2px solid rgba(1, 4, 7, 0.05);
}
.share-links >>> svg path {
  fill: #dadada;
}
.share-links p {
  color: #dadada;
}
.share-links svg {
  margin-left: 15px;
}
.share-links a {
  margin-left: 10px;
}
.share-links a svg path {
  transition: 0.4s ease;
}
.share-links a:hover svg path {
  fill: var(--tbc-blue) !important;
  transition: 0.4s ease;
}
.tags-list {
  margin-top: 32px;
  padding-bottom: 24px;
}
.tags-list h3 {
  color: var(--secondary);
  margin-bottom: 20px;
}
.tags-list ul {
  display: flex;
  flex-wrap: wrap;
}
.tags-list ul li {
  background: #e8e8e8;
  padding: 7px 13px;
  color: black;
  border-radius: 1px solid #d9d9d9;
  margin-bottom: 10px;
  margin-right: 10px;
  border-radius: 6px;
}
</style>
<style>
.share-tags-cont body[data-theme="night"] .offer-type-button {
  background: var(--gray);
}
</style>
